import { Row } from "@neru/ui";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

interface OverviewProps {
  description: string;
}

export const Overview = ({ description }: OverviewProps) => (
  <Row>
    <ReactMarkdown
      className="markup neru-markup"
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >
      {description}
    </ReactMarkdown>
  </Row>
);
